<template>
  <header class="d-sm-flex justify-content-between align-items-center">
    <h1>{{ title }}</h1>
    <b-button variant="light" :to="{name: 'Vehicles'}">← Volver</b-button>
  </header>
</template>

<script>
export default {
  name: 'VehiclesHeader',
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
